<template>
  <div>
    <p class="cm-mg-p-wzd text-left text-muted">
      2.1 {{ $t('sowing.sowing_method_info_indication') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12 col-md-4 col-lg-3">
        <div class="row">
          <div class="col-12">
            <fg-input
              :label="`${$t('common_words.distance')}(m):`"
              type="number"
              v-model="model.distance"
              name="common_words.distance"
              v-validate="modelValidations.distance"
              :error="getError('common_words.distance', true)"
              :placeholder="$t('common_words.distance_enter_meters')"
            ></fg-input>
          </div>
          <div class="col-12">
            <fg-input
              :label="`${$t('climate.temperature')}(°C):`"
              type="number"
              v-model="model.temperature"
              name="climate.temperature"
              v-validate="modelValidations.temperature"
              :error="getError('climate.temperature', true)"
              :placeholder="$t('climate.enter_temperature_celcius')"
            ></fg-input>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.description') }}:</label>
            <br />
            <el-input
              maxlength="150"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :rows="5"
              :placeholder="`${$t('sowing.sowing_method_description')}...`"
              v-model="model.description"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';

export default {
  data() {
    return {
      model: {
        distance: null,
        temperature: null,
        description: null,
      },
      modelValidations: {
        distance: {},
        temperature: {},
      },
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],
  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', this.model);
          return res;
        })
        .then((resp) => {
          return store.dispatch(
            'utils/validationInputsRequired',
            '-second-step'
          );
        });
    },
  },

  created() {},

  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { distance, temperature, description } = JSON.parse(
        sessionStorage.getItem('editForm')
      );
      this.model = {
        distance,
        temperature,
        description,
      };
    }
  },
};
</script>
<style></style>
